import { BREAKPOINT_MEDIUM } from 'global-search-shared';
import styled from 'foundations-theming-specialty/utils';
export const StyledSearchIcon = styled.svg.withConfig({
  displayName: "StyledSearchIcon",
  componentId: "sc-1duvmuc-0"
})(["width:16px;height:16px;fill:var(--search-input-color);position:absolute;top:50%;transform:translateY(-50%);left:", ";pointer-events:none;z-index:2;@media (max-width:", "px){left:", ";}"], ({
  theme
}) => theme.space['500'], BREAKPOINT_MEDIUM - 1, ({
  theme
}) => theme.space['300']);
export const StyledSearchIconTrellis = styled.svg.withConfig({
  displayName: "StyledSearchIcon__StyledSearchIconTrellis",
  componentId: "sc-1duvmuc-1"
})(["width:16px;height:16px;fill:var(--search-input-color);position:absolute;pointer-events:none;z-index:2;"]);